import { SVGProps, Ref, forwardRef } from 'react';

export const ImageHyperstarFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="m13.82 17.426 3.623-2.848 4.98 4.113C21.399 22.335 18.695 23 12 23s-9.398-.665-10.424-4.309l6.797-5.539z"
                fill="currentColor"
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12 1c9.625 0 11 1.375 11 11 0 1.842-.05 3.382-.2 4.668l-5.33-4.401-3.652 2.87-5.466-4.29L1.2 16.677C1.05 15.388 1 13.846 1 12c0-2.014.062-3.666.245-5.02a11.4 11.4 0 0 1 1.757 2.018L4.5 11.245l1.498-2.247a11.5 11.5 0 0 1 3-3L11.245 4.5 8.998 3.002a11.4 11.4 0 0 1-2.019-1.757C8.334 1.062 9.986 1 12 1m3.5 4.75c-1.312 0-1.75.875-1.75 1.75s.438 1.75 1.75 1.75 1.75-.875 1.75-1.75-.437-1.75-1.75-1.75"
                fill="currentColor"
            />
            <path
                d="M4.5 1A13.3 13.3 0 0 0 8 4.5 13.3 13.3 0 0 0 4.5 8 13.3 13.3 0 0 0 1 4.5 13.3 13.3 0 0 0 4.5 1"
                fill="currentColor"
            />
        </g>
    </svg>
));
ImageHyperstarFilledSize24Glyph.displayName = 'ImageHyperstarFilledSize24Glyph';
